import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import s from './AffiliateWidget.scss';

class AffiliateCard extends React.Component {
  render() {
    const gaAttr = [];
    const { gaData, tagData, url } = this.props;
    if (gaData) {
      gaAttr.push(gaData);
    }
    gaAttr.push(this.props.amz_ga);
    if (gaData) {
      //emptry string,
      //as data-ga needs 3rd arg
      gaAttr.push('');
    }

    const scrollGAAttr = {
      ...(gaData && { 'data-ga': gaAttr.join('|') }),
      ...(!gaData && { 'data-newga': gaAttr.join('#') }),
    };
    const finalURl = `${url}?tag=${tagData}`;
    return (
      <div className={s.slickinner} key={this.props.index}>
        <Link to={finalURl} {...this.props} target="_blank" {...scrollGAAttr}>
          <div className={s.inner}>
            <figure>
              <Image
                src={this.props.imgsrc || this.props.imageUrl}
                alt={this.props.title}
                placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                lazyload
                offsetVertical={200}
              />
            </figure>
            <h5 className={s.title}>{this.props.title}</h5>
            {!this.props.type && (
              <div className={s.pricewrapper}>
                <div className={`${s.mrp} ${s.orgprice}`}>
                  <span className={s.mrpprice}>
                    {this.props.price || this.props.offprice}
                  </span>
                  <span>
                    <button type="button" className={s['buy-btn']}>
                      {/* {this.props.amzicon.text} */}
                      Buy
                    </button>
                  </span>
                </div>
                {this.props.discount ? (
                  <div className={s.discounted_price}>
                    <span className={s.mrp}>
                      {this.props.listprice || this.props.mrp}
                    </span>
                    ({parseInt(this.props.discount, 10)}% OFF)
                  </div>
                ) : null}
              </div>
            )}
            {this.props.type &&
              this.props.offertext &&
              this.props.type === 'banner' && (
                <div className={s.offertxt}>{this.props.offertext}</div>
              )}
            <footer>
              <span className={s.col}>
                <i className={s['amazon-logo']} />
              </span>
            </footer>
          </div>
        </Link>
      </div>
    );
  }
}

AffiliateCard.propTypes = {
  title: PropTypes.string,
  amzicon: PropTypes.shape({
    text: PropTypes.string,
  }),
  imgsrc: PropTypes.string,
  listprice: PropTypes.string,
  price: PropTypes.string,
  imageUrl: PropTypes.string,
  offprice: PropTypes.string,
  mrp: PropTypes.string,
  url: PropTypes.string,
  amz_ga: PropTypes.string,
  discount: PropTypes.string,
  notLazyLoadImages: PropTypes.bool,
};
AffiliateCard.defaultProps = {
  title: '',
  amzicon: {
    text: '',
  },
  imgsrc: '',
  listprice: '',
  price: '',
  imageUrl: '',
  offprice: '',
  mrp: '',
  url: '',
  amz_ga: '',
  discount: '',
  notLazyLoadImages: false,
};
export default AffiliateCard;
